export default __webpack_public_path__ + "static/media/e-nstitute-desktop-two.8f23fc21.png";